import {
  SET_TYPE_PLAYER_LOCK,
  RESET_TYPE_PLAYER_LOCK,
} from '../../constants/playerLock';

export const setTypePlayerLock = (payload) => ({
  type: SET_TYPE_PLAYER_LOCK,
  payload,
});

export const resetTypePlayerLock = () => ({ type: RESET_TYPE_PLAYER_LOCK });
